import BaseModelAPI from '../BaseModelAPI';

export default class Part extends BaseModelAPI {
	static entity = 'part';
	static entityName = 'part';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.partNumber = '';
		this.partName = '';
		this.partSpecification = '';
		this.partReferenceId = '';
		this.partReference = {};
		this.customerId = '';
		this.customer = {};
		this.isDirectDelivery = false;
		this.stockLevelCustomer = 0;
		this.partClassificationId = '';
		this.partClassification = {};
		this.packagingTypeId = '';
		this.packagingType = {};
		this.uomId = '';
		this.uom = {};
		this.uomPoId = '';
		this.uomPo = {};
		this.standarPackagingQty = 0;
		this.vendorSubcontractId = '';
		this.vendorSubcontract = {};
		this.isNeedRepacking = false;
		this.partDetail = []
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		this.partNameCombination = '';
		/*END_APP_MODEL_DEFINITION*/
	}

}